import type { FaireProductEntity } from "../../entity_types/product";

export const p_umd8qrvq5z: FaireProductEntity = {
  token: "p_umd8qrvq5z",
  type: "product",
  name: "Liver Support",
  brandToken: "b_daeyv9q8xk",
  brandName: "Nutra Moment",
  imageUrl:
    "https://cdn.faire.com/fastly/9a8227a37e1bd67b57deac6f4c948535d1fe358220777d967976015b7fe4b37f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ad0dbdf90ac90538d031e253868dd5745b6f4d5d2d207298d159c602e1484c59.jpeg",
    "https://cdn.faire.com/fastly/cab7efd1c0830eee61fb8516ecbe5e3684c0d62ae99ac1c555ff29c4876c1abc.jpeg",
    "https://cdn.faire.com/fastly/39c9117dc6250afe5a2f52bcd6d5378097e10cc4330e95ec7d066f458e87b3df.jpeg",
  ],
  priceDollars: 11.49,
  description:
    "\n \n\nOur liver Support contains 200 mg of Milk Thistle, also known as Silybum Marianum, a herbal treatment with antioxidant, antiviral, and anti-inflammatory qualities that support and aid in the detoxification of your liver. Our product has an innovative mix that includes important natural elements (minerals and organic herbs).†\n\n\nAssist Liver detoxification † \n\nMilk thistles have antiviral and anti-inflammatory, and antioxidant properties that fight against oxidative stress. It supports liver health and detoxification.†\n\nAssist Digestive Enzymes † \n\nA healthy, functioning liver is an essential part of good health. Taking our liver support supplement will help with your energy levels, immunity, digestion, and overall wellbeing.",
  tags: [],
  msrpDollars: 22.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:54:41.824Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
